import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AsyncSubject, BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import { AccountService } from 'src/app/shared/services/custom/account.service';

declare global {
  interface Window {
    _dragOver$ : AsyncSubject<Observable<any>>
    _drop$ : BehaviorSubject<any>;
    _updateDropHandler: any
  }
}

@Component({
  selector: 'app-edit-page',
  templateUrl: './edit-page.component.html',
  styleUrls: ['./edit-page.component.scss']
})
export class EditPageComponent implements AfterViewInit {
  @ViewChild('fakeDrop', {static: true}) fakeDrop : ElementRef;

  constructor(private cdr : ChangeDetectorRef, account : AccountService, router : Router) {
    if (!account.isAdminUser()) {
      router.navigateByUrl('/admin/login');
      return;
    }

    window._dragOver$ = new AsyncSubject();
    window._drop$ = new BehaviorSubject(null);

    window._updateDropHandler = this.updateDropHandler.bind(this);
  }

  dragOver$;

  ngAfterViewInit(): void {
    this.dragOver$ = fromEvent(this.fakeDrop.nativeElement, 'dragover').pipe(
      throttleTime(50)
    );

    window._dragOver$.next(this.dragOver$);
    window._dragOver$.complete();
  }

  onDrop(event) {
    event.preventDefault();
    window._drop$.next(event);
    this.notDrag = true;
    this.cdr.detectChanges();
  }

  updateDropHandler() {
    window._drop$ = new BehaviorSubject(null);
  }

  dragOver(event) {
    event.preventDefault();
  }

  onDragLeave(event) {
    event.preventDefault();
    window._drop$.next(null);
  }

  notDrag = true;

  onDrag(event) {
    if (event == 'start') {
      this.notDrag = false;
      this.cdr.detectChanges();
    }
    else if (event == 'end') {
      this.notDrag = true;
      this.cdr.detectChanges();
    }
  }

}
